import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar, Phone, Settings, MessageSquare } from "lucide-react";
import { CALENDLY_ONBOARDING_URL } from "@/config/support";

interface SkipAllDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmSkip: () => void;
}

export function SkipAllDialog({ open, onOpenChange, onConfirmSkip }: SkipAllDialogProps) {
  const handleBookCall = () => {
    window.open(CALENDLY_ONBOARDING_URL, '_blank');
    onConfirmSkip();
    onOpenChange(false);
  };

  const handleSkipWithoutCall = () => {
    onConfirmSkip();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mx-auto mb-2">
            <Phone className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle className="text-center">Besoin d'aide pour configurer ?</DialogTitle>
          <DialogDescription className="text-center">
            Nous vous proposons un appel gratuit de 30 minutes pour configurer votre établissement ensemble.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 py-4">
          <div className="flex items-start gap-3">
            <Settings className="w-5 h-5 text-primary mt-0.5" />
            <div>
              <p className="font-medium text-sm">Configuration personnalisée</p>
              <p className="text-sm text-muted-foreground">Nous adaptons la solution à vos besoins spécifiques</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MessageSquare className="w-5 h-5 text-primary mt-0.5" />
            <div>
              <p className="font-medium text-sm">Réponses à vos questions</p>
              <p className="text-sm text-muted-foreground">Posez toutes vos questions sur l'utilisation</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Calendar className="w-5 h-5 text-primary mt-0.5" />
            <div>
              <p className="font-medium text-sm">Créneaux flexibles</p>
              <p className="text-sm text-muted-foreground">Choisissez le moment qui vous convient</p>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button onClick={handleBookCall} className="w-full">
            <Calendar className="w-4 h-4 mr-2" />
            Réserver un appel
          </Button>
          <Button 
            variant="ghost" 
            onClick={handleSkipWithoutCall}
            className="w-full text-muted-foreground"
          >
            Passer sans appel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
